<as-split [useTransition]="true" [gutterSize]="6">
  <as-split-area #treeArea="asSplitArea" [size]="45" class="h-full w-full relative">
    <y42-git-diff-tree
      class="block h-full"
      [changes]="changes"
      [selectedItems]="selectedItems"
      (selectedItemsChange)="selectedItemsChange.emit($event)"
      [allowCheckboxSelection]="allowCheckboxSelection"
      [getContextMenuItems]="getContextMenuItems"
      [activeItem]="activeItem"
      (activeItemChange)="setActiveFile($event)"
      [disableContextMenu]="disableFileTreeContextMenu"
    ></y42-git-diff-tree>
  </as-split-area>

  <as-split-area #diffArea="asSplitArea" [size]="55" class="h-full w-full relative flex flex-col text-left">
    <ng-container *ngIf="activeItem" class="w-full">
      <div class="px-2 border-bottom h-[56px] flex bg-background-primary">
        <div class="h-full pl-2 pt-2" style="width: calc(100% - 100px)">
          <div class="text-left text-sm font-semibold">{{ activeItem.fileName.split('.')[0] }}</div>
          <div class="text-left text-xs text-gray-700 truncate" [matTooltip]="activeItem.path">
            {{ activeItem.path }}
          </div>
        </div>
        <div class="aligner-end w-[100px]">
          <!-- <mat-button-toggle-group
            [formControl]="viewSelectorFC"
            [intercomTarget]="'uivscode-commit'"
            class="toggle-group-deep-style"
          >
            <mat-button-toggle [value]="'source'">
              <fa-icon class="fs-07" [icon]="['fal', 'code']"></fa-icon>&nbsp;Code
            </mat-button-toggle>
            <mat-button-toggle [value]="'ui'">
              <fa-icon class="fs-07" [icon]="['fal', 'paint-brush']"></fa-icon>&nbsp;UI
            </mat-button-toggle>
          </mat-button-toggle-group>-->
          <ng-content select="[aligner-end]"></ng-content>
        </div>
      </div>
      <ng-container *ngIf="activeItem">
        <div
          *ngIf="viewSelectorFC.value === 'source'"
          class="merge-editor flex-1 w-full"
          y42MonacoDiffEditor
          [fileName]="activeItem.fileName"
          [original]="activeItem.original"
          [modified]="activeItem.modified"
        ></div>
        <div *ngIf="viewSelectorFC.value === 'ui'" class="flex">
          <y42-git-ui-display-outlet
            [path]="activeItem.path"
            [content]="activeItem.original"
          ></y42-git-ui-display-outlet>
          <y42-git-ui-display-outlet
            [path]="activeItem.path"
            [content]="activeItem.modified"
          ></y42-git-ui-display-outlet>
        </div>
      </ng-container>
    </ng-container>
  </as-split-area>
</as-split>
